import type { FriendContact, FriendPresence } from '../network/SocialService';

export interface FriendPresencePresentation {
  presence: FriendPresence;
  aria: string;
  status: string;
}

export function friendPresence(friend: Pick<FriendContact, 'online' | 'presence'>): FriendPresence {
  if (friend.presence === 'station' || friend.presence === 'crew' || friend.presence === 'queue' || friend.presence === 'match' || friend.presence === 'offline') {
    return friend.presence;
  }
  // Rolling compatibility with an API revision that only published `online`.
  return friend.online ? 'station' : 'offline';
}

export function presentFriendPresence(friend: Pick<FriendContact, 'online' | 'presence'>): FriendPresencePresentation {
  const presence = friendPresence(friend);
  switch (presence) {
    case 'station': return { presence, aria: 'online in Station', status: 'ONLINE // STATION' };
    case 'crew': return { presence, aria: 'forming a crew', status: 'FORMING CREW' };
    case 'queue': return { presence, aria: 'joining a match', status: 'MATCHMAKING' };
    case 'match': return { presence, aria: 'in a match', status: 'ABOARD A TRAIN' };
    default: return { presence, aria: 'offline', status: 'OFFLINE' };
  }
}

export function friendUnreadStatus(friend: Pick<FriendContact, 'online' | 'presence'>, unreadCount: number): string {
  const channel = ({
    station: 'STATION', crew: 'CREW', queue: 'QUEUE', match: 'MATCH', offline: 'OFFLINE',
  } as const)[friendPresence(friend)];
  return `${channel} // NEW ×${Math.max(0, Math.floor(unreadCount))}`;
}
